import React, { useEffect, useState } from 'react'
import './CookiesConsent.scss'
import { getCookie, setCookie } from 'react-use-cookie'
import BlurOverlay from "../BlurOverlay";

function CookiesConsent() {
  const [cookiesConsentOpen, setCookiesConsentOpen] = useState(false)

  const consentCookies = () => {
    setCookie('consentCookie', 'accepted')
    document.body.classList.remove('disable-scroll', 'overflow-hidden')
    setCookiesConsentOpen(false)
  }

  const rejectCookies = () => {
    setCookie('consentCookie', 'rejected')
    document.body.classList.remove('disable-scroll', 'overflow-hidden')
    setCookiesConsentOpen(false)
  }

  useEffect(() => {
    if (getCookie('consentCookie') !== 'accepted' && getCookie('consentCookie') !== 'rejected') {
      const timeoutId = setTimeout(() => {
        setCookiesConsentOpen(true)
      }, 2000)
      return () => clearTimeout(timeoutId)
    }
  }, [cookiesConsentOpen])

  if (!cookiesConsentOpen) {
    return null
  }

  return (
    <>
      {cookiesConsentOpen ? <BlurOverlay isOverlayOpen={cookiesConsentOpen} section={'cookiesConsent'}></BlurOverlay> : ''}
      <div className="cookies-consent-panel">
        We and selected third parties use cookies or similar technologies for technical purposes and, with your consent, for other purposes as specified in the cookie policy.
        Use the “Accept” button to consent. Use the “Reject” button or close this notice to continue without accepting.
        <div className={'form-group'}>
          <button className={'button'} onClick={consentCookies}>Accept</button>
          <button className={'button'} onClick={rejectCookies}>Reject</button>
        </div>
      </div>
    </>
  )
}

export default CookiesConsent
